import Client from 'config/axios';

export const getChallenges = async (
  token: string,
  limit: number,
  page: number
) => {
  const { data } = await Client.get(
    `challenge/all?limit=${limit}&page=${page}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return {
    data
  };
};
